export default "__VITE_ASSET__55002d47__"